import { createSlice } from '@reduxjs/toolkit';
import { GetQuartzJobs } from './thunks/get-quartz-jobs.thunk';
import { QuartzMonitorState } from './quartz-monitor.state';

const initialState: QuartzMonitorState = {
    jobs: [],
    isLoading: false,
    status: 'succeeded',
    error: '',
};

const quartzMonitorSlice = createSlice({
    name: 'quartzMonitor',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(GetQuartzJobs.pending, (state) => setPendingState(state))
            .addCase(GetQuartzJobs.fulfilled, (state, action) => {
                const { jobs } = action.payload;
                state.jobs = jobs;
                setSucceededState(state);
            })
            .addCase(GetQuartzJobs.rejected, (state) => setRejectedState(state));
    },
});

const setRejectedState = (state: any) => {
    state.isLoading = false;
    state.status = 'failed';
    state.error = state;
};

const setPendingState = (state: any) => {
    state.isLoading = true;
    state.status = 'loading';
    state.error = '';
};

const setSucceededState = (state: any) => {
    state.isLoading = false;
    state.status = 'succeeded';
    state.error = '';
};

export const {} = quartzMonitorSlice.actions;
export default quartzMonitorSlice.reducer;
